// import { useTranslation } from "react-i18next";
// import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
// import { DownloadFileByFileStoreId } from "../components/DownloadFileByFileStoreId";
// import { RenderNavItem } from "../components/RenderNavItem";
import { TableStructure } from "../components/TableStructure";
import { MapsOfMarketDocList, MarketLeftNavsList } from "../utils/constants";

const Maps_of_market = () => 
<TableStructure
title="Maps of deep tubewells situated in the market area for fire fighting"
heading={false}
list={MapsOfMarketDocList}
columnNo={1}
leftMenuList={MarketLeftNavsList}
longMenuList={true}
/>





// {
//   const { t } = useTranslation();
//   return (
//     <>
//       <section id="hero" className="hero hero2">
//         <LeftSocialMediaIconUI />

//         <div className="carousel-item active">
//           <img
//             src="assets/img/Banner/portal-banner8.jpg"
//             className="img-fluid"
//             alt="alt"
//           />
//           {/* <div className="container">
//             <div className="section-main-heading2">
//               <h4 className="fontSizeClass"></h4>
//             </div>
//           </div> */}
//         </div>
//       </section>
//       <section className="section inner-pad1">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-3">
//               <div className="site-menu  min-height-400">
//                 <nav className="sidebar card py-2">
//                   <ul className="nav flex-column" id="nav_accordion">
//                     {MarketLeftNavsList.map((item, index) => (
//                       <RenderNavItem item={item} index={index} t={t} />
//                     ))}
//                   </ul>
//                 </nav>
//               </div>
//             </div>
//             <div className="col-lg-9">
//               <div className="container">
//                 <div className="row">
//                   <div className="inner-title2">
//                     <h3 className="fontSizeClass">
//                       {t(
//                         "Maps of deep tubewells situated in the market area for fire fighting"
//                       )}
//                     </h3>
//                   </div>
//                   <div className="dig-login2">
//                     <div className="row">
//                       <div className="col-md-6">
                      
//                       {MapsOfMarketDocList.map((item, index) => (
//                           <h6 className="fontSizeClass">
//                             {/* <a
//                               href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18004526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
//                             >
//                               1. Spout_WD-61,62_Final.
//                             </a> */}
//                             {index + 1}.{" "}
//                             <DownloadFileByFileStoreId fileStoreId={item.fileStoreId} label={item.label} />
//                           </h6>
//                         ))}

                       
//                         {/* <h6 className="fontSizeClass">
//                           <a
//                             href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18004526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
//                           >
//                             1. Spout_WD-61,62_Final.
//                           </a>
//                         </h6>
//                         <h6 className="fontSizeClass">
//                           <a
//                             href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18004626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
//                           >
//                             2. Spout_WD-66_Final.
//                           </a>
//                         </h6>
//                         <h6 className="fontSizeClass">
//                           <a
//                             href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18004726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
//                           >
//                             3. Spout_WD-67_Final.
//                           </a>
//                         </h6>
//                         <h6 className="fontSizeClass">
//                           <a
//                             href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18004826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
//                           >
//                             4. Spout_WD-68_Final.
//                           </a>
//                         </h6>
//                         <h6 className="fontSizeClass">
//                           <a
//                             href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18004926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
//                           >
//                             5. Spout_WD-69_Final.
//                           </a>
//                         </h6>
//                         <h6 className="fontSizeClass">
//                           <a
//                             href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18005026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
//                           >
//                             6. Spout_WD-73_Final.
//                           </a>
//                         </h6>
//                         <h6 className="fontSizeClass">
//                           <a
//                             href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18005126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
//                           >
//                             7. Spout_WD-74_Final.
//                           </a>
//                         </h6>
//                       </div>
//                       <div className="col-md-6">
//                         <h6 className="fontSizeClass">
//                           <a
//                             href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18005226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
//                           >
//                             8. Spout_WD-78_Final.
//                           </a>
//                         </h6>
//                         <h6 className="fontSizeClass">
//                           <a
//                             href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18005326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
//                           >
//                             9. Spout_WD-81,82,83,88_Final.
//                           </a>
//                         </h6>
//                         <h6 className="fontSizeClass">
//                           <a
//                             href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18005426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
//                           >
//                             10. Spout_WD-89_Final.
//                           </a>
//                         </h6>
//                         <h6 className="fontSizeClass">
//                           <a
//                             href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18005526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
//                           >
//                             11. Spout_WD-91_Final.
//                           </a>
//                         </h6>
//                         <h6 className="fontSizeClass">
//                           <a
//                             href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18005626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
//                           >
//                             12. Spout_WD-92_Final.
//                           </a>
//                         </h6>
//                         <h6 className="fontSizeClass">
//                           <a
//                             href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18005726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
//                           >
//                             13. Spout_WD-93_Final.
//                           </a>
//                         </h6>
//                         <h6 className="fontSizeClass">
//                           <a
//                             href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18022926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
//                           >
//                             14. Spout_WD_57_58_Final.
//                           </a>
//                         </h6> */}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

export default Maps_of_market;
